import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IResponse } from '@/Module/Core/Model/ApiModel';
import type { IGetTotalNotification } from '@/Module/Profile/Model/ApiModel';
import NotificationService from '@/Module/Profile/Service/NotificationService';

export const getAllReadNotificationAction = createAsyncThunk<IResponse, IGetTotalNotification>(
  'notification/getAllReadNotificationAction',
  async (req, { signal }) => {
    return NotificationService.getAllReadNotification({ ...req }, signal).then(({ data: { data } }) => data);
  },
);
